import { services } from "../../../../constants";

export default async function userExists(data) {
  const url = `${this.backendHosts.auth}${services.userExists}`;
  try {
    const response = await this.http.post(url, data, await this.getHeaders());
    return response;
  } catch (error) {
    this.handleErrorResponse(error);
  }
}
